import { render } from "./addAlert.vue?vue&type=template&id=db65e176"
import script from "./addAlert.vue?vue&type=script&lang=js"
export * from "./addAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__